import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CustomerApi } from "../lib/api/CustomerApi";
import { Alert } from "../lib/alert";
import { KycApi } from "../lib/api/KycApi";

import provinces from "../lib/list_of_area/provinces.json";
import regencies from "../lib/list_of_area/regencies.json";
import districts from "../lib/list_of_area/districts.json";
import villages from "../lib/list_of_area/villages.json";

const ViewProfileLayer = () => {
  const { id } = useParams();

  // redirect back if id is not provided

  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const [role, setRole] = useState(user.role); // Default role
  const [status, setStatus] = useState(user.status); // Default status

  const [imagePreview, setImagePreview] = useState(
    "/assets/images/user-grid/user-grid-img13.png"
  );
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const [kycProfile, setKycProfile] = useState({});
  const [fullCurrentAddress, setFullCurrentAddress] = useState("");
  const [kycStatus, setKycStatus] = useState(""); // Default KYC status

  const kyc_status = [
    { value: "rejected", label: "Rejected" },
    { value: "approved", label: "Approved" },
  ];

  useEffect(() => {
    if (id === 1 || id === undefined || id === null) {
      window.location.href = "/users-list";
      return null; // or you can return a message or redirect component
    }

    const fetchUser = async () => {
      try {
        const response = await CustomerApi.show(id); // Sesuaikan dengan API yang kamu gunakan
        if (response.error_code !== 200) {
          throw new Error(response.message);
        }

        setUser(response.data); // atau sesuaikan dengan struktur responsmu
        setLoading(false);
      } catch (error) {
        setErrorMsg("Gagal mengambil data sales.");
        setLoading(false);
      }
    };

    fetchUser();
    getKycProfile(id);
  }, []);

  // Toggle function for password field
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Toggle function for confirm password field
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.target.files[0]);
    }
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined) {
      return "-";
    }
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) {
      return "-";
    }
    return numberValue.toLocaleString("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg("");
    try {
      const formData = { status, role };

      // Call your API to update the user data
      CustomerApi.update(id, formData)
        .then((response) => {
          if (response.error_code === 200) {
            setUser(response.data);
            Alert.success("Success", "Data pengguna berhasil disimpan.");
          } else {
            setErrorMsg(response.message || "Gagal menyimpan data pengguna.");
          }
        })
        .catch((error) => {
          setErrorMsg(error.message || "Gagal menyimpan data pengguna.");
        });
    } catch (error) {
      setErrorMsg("Gagal menyimpan data pengguna.");
    }
  };

  const handleVerify = (id) => {
    try {
      CustomerApi.verify(id)
        .then((response) => {
          if (response.error_code === 200) {
            Alert.success("Success", "User verified successfully.");
            window.location.reload();
          } else {
            Alert.error("Error", response.message || "Failed to verify user.");
          }
        })
        .catch((error) => {
          Alert.error("Error", error.message || "Failed to verify user.");
        });
    } catch (error) {
      Alert.error("Error", "An unexpected error occurred.");
    }
  };

  const getKycProfile = async (id) => {
    try {
      const response = await KycApi.kyc_profile({ id });
      if (response.error_code !== 200) {
        throw new Error(response.message);
      }
      setKycProfile(response.data);
      setKycStatus(response.data.status || ""); // Set KYC status from response
      // console.log("KYC Profile fetched successfully:", response.data);
      const address = JSON.parse(response.data.current_address || "{}");
      if (address) {
        const province = provinces.find((p) => p.id === address.province)?.name;
        const regency = regencies.find((r) => r.id === address.regency)?.name;
        const district = districts.find((d) => d.id === address.district)?.name;
        const village = villages.find((v) => v.id === address.village)?.name;

        setFullCurrentAddress(
          `${address.specific || ""}, ${village || ""}, ${district || ""}, ${
            regency || ""
          }, ${province || ""}`
        );
      }
    } catch (error) {
      console.error("Error fetching KYC profile:", error);
      Alert.error("Error", "Failed to fetch KYC profile.");
      return null;
    }
  };

  const handleKycStatus = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    try {
      const status = kycStatus; // Use the state value for KYC status

      console.log("Updating KYC status:", status, "for ID:", id);
      if (!status || !id) {
        throw new Error("Status and ID are required parameters.");
      }
      if (status !== "approved" && status !== "rejected") {
        throw new Error("Status must be either 'Approved' or 'Rejected'.");
      }
      // sleep for 4 second to simulate delay
      // await new Promise((resolve) => setTimeout(resolve, 4000));
      // return;

      const response = await KycApi.kyc_status({ status, id });
      if (response.error_code !== 200) {
        throw new Error(response.message);
      }
      Alert.success("Success", "KYC status updated successfully.");
      window.location.reload();
    } catch (error) {
      Alert.error("Error", error.message || "Failed to update KYC status.");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
          <img
            src="/assets/images/user-grid/user-grid-bg1.png"
            alt=""
            className="w-100 object-fit-cover"
          />
          <div className="pb-24 ms-16 mb-24 me-16  mt--100">
            <div className="text-center border border-top-0 border-start-0 border-end-0">
              <img
                src={
                  user.profile_img ||
                  "/assets/images/user-grid/user-grid-img13.png"
                }
                alt=""
                className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
              />
              <h6 className="mb-0 mt-16">{user.name}</h6>
              <span className="text-secondary-light mb-16">
                {user.role} ({user.id})
              </span>
            </div>
            <div className="mt-24">
              <h6 className="text-xl mb-16">Personal Info</h6>
              <ul>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Full Name
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {user.name}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Email
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {user.email || "-"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Account Number
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {user.account_number || "-"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Balance
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formatCurrency(user.balance) || "-"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Phone Number
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {user.phone_number || "-"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Address
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {user.address || "-"}
                  </span>
                </li>

                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Email Verified At
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {user.email_verified_at || "-"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Status
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {user.status}
                  </span>
                </li>
              </ul>
              {user.account_number == "NaN" && (
                <div className="d-flex align-items-center justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-success border border-success-600 text-md px-56 py-12 radius-8 mt-16"
                    onClick={() => {
                      handleVerify(user.id);
                    }}
                  >
                    <Icon icon="solar:edit-bold" className="icon me-8" /> Verify
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-8">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Profile
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24"
                  id="pills-change-passwork-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-change-passwork"
                  type="button"
                  role="tab"
                  aria-controls="pills-change-passwork"
                  aria-selected="false"
                  tabIndex={-1}
                >
                  KYC
                </button>
              </li>
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24"
                  id="pills-notification-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-notification"
                  type="button"
                  role="tab"
                  aria-controls="pills-notification"
                  aria-selected="false"
                  tabIndex={-1}
                >
                  Notification Settings
                </button>
              </li> */}
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                {/* Upload Image Start */}
                <div className="mb-24 mt-16">
                  <div className="avatar-upload">
                    <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                      <input
                        type="file"
                        id="imageUpload"
                        accept=".png, .jpg, .jpeg"
                        hidden
                        onChange={readURL}
                      />
                      <label
                        htmlFor="imageUpload"
                        className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                      >
                        <Icon
                          icon="solar:camera-outline"
                          className="icon"
                        ></Icon>
                      </label>
                    </div>
                    <div className="avatar-preview">
                      <div
                        id="imagePreview"
                        style={{
                          backgroundImage: `url(${imagePreview})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Upload Image End */}
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="name"
                          placeholder="Enter Full Name"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control radius-8"
                          id="email"
                          placeholder="Enter email address"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="number"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Phone
                        </label>
                        <input
                          type="email"
                          className="form-control radius-8"
                          id="number"
                          placeholder="Enter phone number"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="depart"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Department
                          <span className="text-danger-600">*</span>{" "}
                        </label>
                        <select
                          className="form-control radius-8 form-select"
                          id="depart"
                          defaultValue="Select Event Title"
                        >
                          <option value="Select Event Title" disabled>
                            Select Event Title
                          </option>
                          <option value="Enter Event Title">
                            Enter Event Title
                          </option>
                          <option value="Enter Event Title One">
                            Enter Event Title One
                          </option>
                          <option value="Enter Event Title Two">
                            Enter Event Title Two
                          </option>
                        </select>
                      </div>
                    </div>
                    {user.id !== 2 && (
                      <>
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="desig"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Role
                              <span className="text-danger-600">*</span>{" "}
                            </label>
                            <select
                              className="form-control radius-8 form-select"
                              id="desig"
                              defaultValue={user.role}
                              onChange={(e) => setRole(e.target.value)}
                            >
                              <option value="moderator">Moderator</option>
                              <option value="mitra">Mitra</option>
                              <option value="user">User</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="Language"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Status
                              <span className="text-danger-600">*</span>{" "}
                            </label>
                            <select
                              className="form-control radius-8 form-select"
                              id="Language"
                              defaultValue={user.status}
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              {user.status === "active" && (
                                <option value="active">Active</option>
                              )}
                              <option value="muted">Muted</option>
                              <option value="disabled">Blocked</option>
                            </select>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-sm-12">
                      <div className="mb-20">
                        <label
                          htmlFor="desc"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Description
                        </label>
                        <textarea
                          name="#0"
                          className="form-control radius-8"
                          id="desc"
                          placeholder="Write description..."
                          defaultValue={""}
                        />
                      </div>
                    </div>
                  </div>
                  {user.role !== "admin" ? (
                    <div className="d-flex gap-3">
                      <button
                        type="submit"
                        className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      >
                        Save
                      </button>
                    </div>
                  ) : (
                    "-"
                  )}
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table striped-table mb-0">
                            <tbody>
                              {/* 
                            "full_name",
                            "id_number",
                            "birth_date",
                            "npwp",
                            "mother_name",
                            "mother_phone_number",
                            "savings_goal",
                            "work",
                            "salary",
                            "citizenship" ,
                            "religion",
                            "marital_status",
                            "gender",
                            "current_address",
                            "id_card_address",
                            "birth_address",
                            "id_card_photo"  */}
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Nama Lengkap
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.full_name || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        NIK
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.id_number || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Tanggal Lahir
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.birth_date || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        NPWP
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.npwp || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Nama Ibu
                                      </span>

                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.mother_name || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        No. HP Ibu
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.mother_phone_number || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Tujuan Tabungan
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.savings_goal || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Pekerjaan
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.work || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Penghasilan
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {formatCurrency(kycProfile.salary) ||
                                          "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Kewarganegaraan
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.citizenship || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Agama
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.religion || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Status Pernikahan
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.marital_status || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Jenis Kelamin
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.gender || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Alamat Sekarang
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {fullCurrentAddress || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Alamat KTP
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.id_card_address || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Alamat Lahir
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.birth_address || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <span className="text-sm text-secondary-light fw-normal">
                                        Status KYC
                                      </span>
                                      <h6 className="text-md mb-0 fw-normal">
                                        {kycProfile.status || "-"}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                        <form onSubmit={handleKycStatus}>
                          <div className="row">
                            <div className="col-7">
                              <select
                                className="form-select radius-8"
                                id="kycStatus"
                                value={kycStatus || ""}
                                onChange={(e) => setKycStatus(e.target.value)}
                              >
                                <option disabled value="pending">
                                  - select -
                                </option>
                                {kyc_status.map((status) => (
                                  <option
                                    key={status.value}
                                    value={status.value}
                                    disabled={
                                      kycProfile.kyc_status === status.value
                                    }
                                  >
                                    {status.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-5">
                              <button
                                type="submit"
                                className="btn btn-primary border border-primary-600 text-md radius-8"
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    {/* card end */}
                  </div>
                  <div className="col-lg-6">
                    <div className="card">
                      {/* <div className="flex-grow-1"> */}
                      {/* <span className="text-sm text-secondary-light fw-normal">
                                        Foto KTP
                                      </span> */}
                      {kycProfile.id_card_photo ? (
                        <img
                          src={kycProfile.id_card_photo}
                          alt="KTP"
                          className="img-fluid mt-2"
                          style={{ maxWidth: "100%" }}
                        />
                      ) : (
                        "-"
                      )}
                      {/* </div> */}
                    </div>
                    <br />
                    <div className="card">
                      {/* <div className="flex-grow-1"> */}
                      {/* <span className="text-sm text-secondary-light fw-normal">
                                        Foto KTP
                                      </span> */}
                      {kycProfile.selfie_photo ? (
                        <img
                          src={kycProfile.selfie_photo}
                          alt="KTP"
                          className="img-fluid mt-2"
                          style={{ maxWidth: "100%" }}
                        />
                      ) : (
                        "-"
                      )}
                      {/* </div> */}
                    </div>
                    {/* card end */}
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-notification"
                role="tabpanel"
                aria-labelledby="pills-notification-tab"
                tabIndex={0}
              >
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="companzNew"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Company News
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="companzNew"
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="pushNotifcation"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Push Notification
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="pushNotifcation"
                      defaultChecked=""
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="weeklyLetters"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Weekly News Letters
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="weeklyLetters"
                      defaultChecked=""
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="meetUp"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Meetups Near you
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="meetUp"
                    />
                  </div>
                </div>
                <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                  <label
                    htmlFor="orderNotification"
                    className="position-absolute w-100 h-100 start-0 top-0"
                  />
                  <div className="d-flex align-items-center gap-3 justify-content-between">
                    <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                      Orders Notifications
                    </span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="orderNotification"
                      defaultChecked=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProfileLayer;
